import { Typography, Box } from "@mui/material"
import WarningIcon from '@mui/icons-material/Warning';
const NotFound = () => {

    return (
        <Box sx={{
            padding: 20,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5
        }}>
            <Box>
                <WarningIcon sx={{ fontSize: 100, color: '#C72930' }} />
            </Box>
            <Box>
                <Typography sx={{
                    fontSize: 55,
                    fontWeight: 900,
                    color: '#C72930'
                }}>Error 404: Page Not Found</Typography>
                <Typography sx={{
                    fontSize: 35,
                }}>We are sorry but the requested page could not be found</Typography>
            </Box>
        </Box>
    )

}

export default NotFound